import { defineMessages } from 'react-intl';
import { EMAIL_REGEX } from 'constants/regexes';
import { isBlank } from 'helpers/verify';

const messages = defineMessages({
  invalidEmail: {
    id: 'validators.email.invalid',
    defaultMessage: 'Please provide a valid email.',
  },
});

export const emailValidator = email => !isBlank(email) && !EMAIL_REGEX.test(email) && messages.invalidEmail;
